import React, { useRef, useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import cn from 'classnames';
import moment from 'moment';
import HubspotForm from 'react-hubspot-form';

import CTA from 'react-scale/components/tailwind/CTA';
import Modal from 'react-scale/components/website/big/main/Modal';
import Spinner from 'react-scale/components/elements/spinner';
import getCookie from 'react-scale/lib/util/get-cookie';

const setHiddenUTMFields = () => {
  let utmParams = {};
  try {
    utmParams = JSON.parse(window.localStorage.getItem('utm_params') || '{}');
    Object.keys(utmParams).forEach(property => {
      const utmField = document.querySelector(`input[name=${property}]`);
      if (utmField) {
        utmField.value = utmParams[property] ?? '';
      }
    });
  } catch (error) {
    // NOTE: ignore error, using localStorage/sessionStorage is disabled in incognito.
  }
};

const SubscribeModal = ({ campaign, cta, title, formContainerCN, ctaCustom, portalId, formId }) => {
  const router = useRouter();
  const [showModal, setShowModal] = useState(false);
  const formWrapperRef = useRef();

  const toggleModal = () => {
    setShowModal(!showModal);
    if (campaign) {
      router.replace(`${router.pathname}?utm_campaign=${campaign}`);
    }
  };

  const handler = async event => {
    const { data, type, id, eventName } = event.data;
    if (type === 'hsFormCallback' && eventName === 'onFormSubmit') {
      if (id === formId) {
        const hutk = getCookie('hubspotutk');

        const body = {
          submittedAt: moment.utc().valueOf(),
          fields: [...data],
          context: {
            ...(hutk ? { hutk } : undefined),
            pageName: document.querySelector('title').text,
            pageUri: window.location.href
          }
        };

        const bodyStr = JSON.stringify(body);

        await fetch(`https://api.hsforms.com/submissions/v3/integration/submit/4823527/${formId}`, {
          method: 'POST',
          body: bodyStr,
          headers: {
            'Content-Type': 'application/json'
          }
        });
      }
    }
  };

  useEffect(() => {
    window.addEventListener('message', handler);
    return () => {
      window.removeEventListener('message', handler);
    };
  }, []);

  return (
    <>
      {cta && (
        <a onClick={toggleModal}>
          <CTA
            cta={{
              text: cta.text,
              colors: {
                bg: 'bg-pink',
                text: 'text-white'
              }
            }}
          />
        </a>
      )}
      {ctaCustom && ( // replace this button with tailwind CTA
        <button
          className={cn(
            'font-medium text-base px-3 leading-6 inline-block rounded-full whitespace-nowrap',
            `${ctaCustom.bg} ${ctaCustom.color}`,
            { uppercase: ctaCustom.uppercase }
          )}
          style={{ width: 'fit-content' }}
          aria-label={ctaCustom.text}
          type="button"
          onClick={toggleModal}
        >
          {ctaCustom.text}
        </button>
      )}
      <Modal title={title} show={showModal} onClick={toggleModal}>
        <div className={formContainerCN} ref={formWrapperRef}>
          <HubspotForm
            portalId={portalId}
            formId={formId}
            target={`.${formContainerCN}`}
            submitButtonClass={cn(
              'font-medium text-base px-6 py-3 leading-relaxed inline-block rounded-full whitespace-nowrap cursor-pointer',
              'bg-black',
              'text-white',
              'hs-button'
            )}
            onReady={() => setHiddenUTMFields()}
            loading={<Spinner size="lg" />}
          />
        </div>
      </Modal>
    </>
  );
};

SubscribeModal.defaultProps = {
  title: 'Subscribe to receive updates',
  cta: {
    customColor: null,
    color: 'primary',
    text: 'Get Updates'
  },
  ctaCustom: null,
  portalId: '4823527',
  formId: '894f2a5e-7ef3-4001-a582-91ed296e0b4b',
  formContainerCN: 'hubspot-subscribe', // custom className for when there are multiple modals in the same page
  campaign: null
};

export default SubscribeModal;
